import React, { useEffect, useState } from "react";
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Link } from "react-router-dom";

import LandingHeader from "../../Components/Landing/LandingHeader";
import LandingFooter from "../../Components/Landing/LandingFooter";
import MyAccountService, { Project } from "../../Services/MyAccountService";
import { useNavigate } from 'react-router-dom';
import CanvasService from "../../Services/CanvasService";
import PhotoBookImg from "../../assets/img/photobook.jpg";
import CanvasImg from "../../assets/img/canvas-img.jpg";
import UserIcon from "../../assets/img/user-icon.svg";
import ProjectIcon from "../../assets/img/project-icon.svg";
import OrderIcon from "../../assets/img/order-icon.svg";
import SettingIcon from "../../assets/img/setting-icon.svg";
import LockIcon from "../../assets/img/lock-icon.svg";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmModal from "./ConfirmModal";
import loadingSpinner from '../../assets/img/Spinner.svg';
import PhotobookEditorService from "../../Services/PhotobookEditorService";
import EmptyProjects from "../../assets/img/no-project.png";

function MyAccounts() {
    const [projects, setProjects] = useState<Project[]>([]);
    const [filter, setFilter] = useState<string>('all'); 
    const [showConfirmModal, setShowConfirmModal] = useState(false); 
    const [projectToDelete, setProjectToDelete] = useState<{ productType: string, associatedProductID: number } | null>(null); // Track project to delete
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [allProjects, setAllProjects] = useState<Project[]>([]);
    const [allCount, setAllCount] = useState(0);
    const [photobookCount, setPhotobookCount] = useState(0);
    const [canvasCount, setCanvasCount] = useState(0);
    const [bannerCount, setBannerCount] = useState(0);

      useEffect(() => {
        fetchProjects('all'); 
      }, []);


        const fetchProjects = async (productType: string) => {
            setLoading(true);
            try {
                const projectData = await MyAccountService.GetMyProjects(productType);
                console.log(projectData);
                setAllProjects(projectData);
                setProjects(projectData);
                setAllCount(projectData.length);
                setPhotobookCount(projectData.filter(project => project.productType === 'photobook').length);
                setCanvasCount(projectData.filter(project => project.productType === 'canvas').length);
                setBannerCount(projectData.filter(project => project.productType === 'banner').length);
            } catch (error) {
                console.error("Error fetching projects:", error);
            } finally {
                setLoading(false);
            }
        };

    
    const handleFilterChange = (type: string) => {
        //setFilter(type); 
        fetchProjects(type); 
    };

    const GetCanvas = (projectDetails: any) => {
        console.log(projectDetails);
        if(projectDetails.productType === "canvas"){
            CanvasService.GetCanvas(projectDetails.associatedProductID).then((canvasData) => {
                navigate(`/canvas`, { state: { canvasData, projectDetails } });
            });
        }else if(projectDetails.productType === "banner"){
            navigate(`/bannereditor`, { state: { projectDetails } });
        }else{
            PhotobookEditorService.GetPhotobook(projectDetails.associatedProductID).then((albumData) => {
                navigate(`/photobookeditor`, { state: { albumData, projectDetails } });
            });
        }
        
    }

    const confirmDeleteProject = (ProductType: string, AssociatedProductID: number) => {
        setProjectToDelete({ productType: ProductType, associatedProductID: AssociatedProductID });
        setShowConfirmModal(true);
    };

    const DeleteProject = async () => {
        if (!projectToDelete) return;

        try {
            const res = await MyAccountService.DeleteProject(projectToDelete.productType, projectToDelete.associatedProductID);
            if (res?.status === 200) {
                toast.success(res?.data?.data, { position: 'top-center' });
                const updatedProjects = await MyAccountService.GetMyProjects(filter);
                setProjects(updatedProjects);
            } else {
                toast.error("Failed to delete project", { position: 'top-center' });
            }
        } catch (error) {
            toast.error('An error occurred during delete project', { position: 'top-right' });
        } finally {
            setShowConfirmModal(false); 
        }
    };

    const createNewProject = () =>{
        navigate(`/home` );
    }

    const extractCanvasSize = (projectName: string | null): React.CSSProperties => {
        const sizeMatch = projectName?.match(/^(\d+)x(\d+)/); 
        if (sizeMatch) {
            const [, width, height] = sizeMatch;
            return {
                maxWidth: `${parseInt(width, 10) * 10}px`, 
                maxHeight: `${parseInt(height, 10) * 10}px`,
                objectFit: "contain", // Valid CSS value
            };
        }
        return {
            width: "176px", // Default width
            height: "112px", // Default height
            objectFit: "cover", // Valid CSS value
        };
    };
    

    return (
        <div className="flex min-h-screen flex-col font-jakarta text-ink antialiased">
            <LandingHeader />

            <section className="MyAccounts login-bg flex-1 pt-6 pb-10">

                <div className="mx-auto max-w-7xl">
                    <div className="grid grid-cols-1 text-2xl font-semibold text-left pb-6"> My Accounts </div>
                    <div className="flex flex-row">
                        <div className="basis-3/12">
                            <div className="mr-10">
                                <ul className="list-none bg-white border border-gray-200 rounded-lg shadow p-5">
                                    {/* <li className="pb-2">
                                        <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                            <img src={UserIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                            <span className="ml-3">My Profile</span>
                                        </button>
                                    </li> */}
                                    <li className="pb-2">
                                        <Link to="/MyAccounts" className=" hover:underline flex text-sm text-inherit">
                                            <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md bg-brand-soft text-brand">
                                                <img src={ProjectIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                                <span className="ml-3">My Projects</span>
                                            </button>
                                        </Link>
                                    </li>
                                    <li className="pb-2">
                                        <Link to="/Orders" className=" hover:underline flex text-sm text-inherit">
                                            <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                                <img src={OrderIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                                <span className="ml-3">My Orders</span>
                                            </button>
                                        </Link>
                                    </li>
                                    <li className="pb-2">
                                        <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                            <img src={SettingIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                            <span className="ml-3">Account & Settings</span>
                                        </button>
                                    </li>
                                    {/* <li className="pb-2">
                                        <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                            <img src={LockIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                            <span className="ml-3">Password</span>
                                        </button>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        {projects.length === 0 ? (
                                   <div className="p-6  md:mx-auto">
                                    <img src={EmptyProjects} alt="Xceedprintsolutions" className='w-20 h-20 mx-auto my-6' />
                                    <div className="text-center">
                                        <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">Looks Like you don’t have any project</h3>
                                        <p className="text-gray-600 my-2">Click the below "New Project"to get started</p>
                                        
                                        <div className="py-10 text-center">
                                         
                                              <button
                                                    className={`px-12 bg-brand hover:bg-brand-dark text-white font-semibold py-3 rounded-full`}
                                                    onClick={() => createNewProject()}
                                                >
                                                    Start New Project 
                                                </button>
                                        </div>
                                </div>
                                </div>
                            ) : (
                                <div className="basis-9/12">
                                    <div className="flex flex-row">
                                        <div className="basis-4/12"> <div className="text-2xl font-normal text-left">My Projects</div></div>
                                        <div className="basis-8/12">
                                            <div className="text-right text-sm text-gray-800 whitespace-nowrap">
                                                Category:
                                                <button
                                                    className={`rounded-full p-1 pl-3 pr-3 mr-3 ml-3 ${filter === 'all' ? 'bg-brand text-white' : 'bg-white'}`}
                                                    onClick={() => handleFilterChange('all')}
                                                >
                                                    All ({allCount})
                                                </button>
                                                <button
                                                    className={`rounded-full p-1 pl-3 pr-3 mr-3 ${filter === 'photoBook' ? 'bg-brand text-white' : 'bg-white'}`}
                                                    onClick={() => handleFilterChange('photobook')}
                                                >
                                                    Photo Books ({photobookCount})
                                                </button>
                                                <button
                                                    className={`rounded-full p-1 pl-3 pr-3 mr-3 ${filter === 'canvas' ? 'bg-brand text-white' : 'bg-white'}`}
                                                    onClick={() => handleFilterChange('canvas')}
                                                >
                                                    Canvas ({canvasCount})
                                                </button>
                                                <button
                                                    className={`rounded-full p-1 pl-3 pr-3 ${filter === 'banner' ? 'bg-brand text-white' : 'bg-white'}`}
                                                    onClick={() => handleFilterChange('banner')}
                                                >
                                                    Banners ({bannerCount})
                                                </button>
                                               
                                            </div>
                                            <div className="text-right text-sm text-gray-800 p-2">
                                                <button
                                                        className={`flex font-semibold text-base text-center items-center justify-center p-2 pl-3 pr-3 w-44 rounded-full bg-brand text-white hover:bg-brand-dark ml-auto`}
                                                        onClick={() => createNewProject()}
                                                    >
                                                    Start New Project 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                        {loading ? (
                                            <div className="text-center my-8">
                                                <img src={loadingSpinner} alt="Loading..." className="mx-auto h-16 w-16" />
                                            </div>
                                        ) : (
                                            <>
                                    
                                        <div className="grid-cols-1">

                                            {projects.map((project) => (
                                                <div key={project.associatedProductID} className="flow-root bg-white border border-gray-200 rounded-lg shadow p-5 my-3">
                                                    <ul role="list" className="-my-6 divide-y divide-gray-200">
                                                        <li className="flex py-6">
                                                        <div
                                                            className="flex-shrink-0 overflow-hidden rounded-md border border-gray-200"
                                                            style={{ width: "152px", height: "98px" }} 
                                                        >
                                                            <img
                                                                src={
                                                                    project.productType === "photobook"
                                                                        ? PhotoBookImg
                                                                        : project?.productImageUrl ?? "fallbackImageURL"
                                                                }
                                                                alt="Xceedprintsolutions"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "contain", 
                                                                    backgroundColor: "#f0f0f0", 
                                                                }}
                                                                className="rounded-md"
                                                            />
                                                        </div>


                                                            <div className="ml-4 flex flex-1 flex-col">
                                                                <div className="flex justify-between text-base font-normal text-gray-900">
                                                                    <div className="text-xl font-medium text-gray-900 mt-1">
                                                                        {project.productType.charAt(0).toUpperCase() + project.productType.slice(1)}
                                                                        <span className="text-sm text-gray-700"> {project.projectName || "Unnamed Project"}</span>
                                                                        <p className="mt-1 text-sm text-gray-600">Last Updated: <span className="font-medium text-gray-800">  {project.lastModified || "N/A"} </span></p>
                                                                        <p className="mt-1 text-sm text-gray-500"> Size:  <span className="font-medium text-gray-800">  {project.productType === "banner" ? (project.projectDesc || `${project.width} X ${project.height}`) : <>{project.width} X {project.height} {project.productType === "canvas" ? "Wrapped canvas (1.5 depth)": ""}</>} </span></p>
                                                                        <p className="mt-1 text-sm text-gray-500">Status: <span className="font-medium text-gray-800"> {project.status || "N/A"} </span></p>
                                                                    </div>

                                                                    <span className="text-xl font-medium text-gray-900 mt-7">${project.productBasePrice.toFixed(2)}</span>

                                                                    <button
                                                                        type="button" onClick={() => GetCanvas(project)}
                                                                        className="mt-5 inline-flex h-10 items-center gap-2 rounded-full border border-brand px-4 py-2 text-xs font-semibold text-brand hover:bg-brand hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand">
                                                                        <PencilIcon aria-hidden="true" className="h-4 w-4" /> Edit
                                                                    </button>
                                                                    <button
                                                                        type="button" onClick={() => confirmDeleteProject(project.productType, project.associatedProductID)}
                                                                        className="rounded-full text-slate-900 hover:bg-gray-200 p-2 mt-0">
                                                                        <TrashIcon aria-hidden="true" className="h-5 w-5" />
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                        
                                        </>
                                    )}
                                </div>
                            )}

                        

                    </div>



                </div>
            </section>
            <LandingFooter />
            <ConfirmModal
                show={showConfirmModal}
                message="Are you sure you want to delete this project?"
                onConfirm={DeleteProject}
                onCancel={() => setShowConfirmModal(false)}
            />
        </div>
    );
}

export default MyAccounts;
